import { Accordion } from "flowbite-react"
  const DjangoFAQ: React.FC = () => { return (
        <>
          <Accordion>
              <Accordion.Panel>
                <Accordion.Title as="h3"  className="accordion-title">What is Django?</Accordion.Title>
                <Accordion.Content className="accordion-border">
                <div className="fs-md mb-0 text-secondary">
                Django is an open-source Python-based framework that is based on the model-template-views architectural pattern for backend development. This technology provides ease to web developers to build rapid, scalable, and reliable websites.
                    </div>
                </Accordion.Content>
              </Accordion.Panel>
              <Accordion.Panel>
                <Accordion.Title as="h3"  className="accordion-title"> Is Django backend or frontend?</Accordion.Title>
                <Accordion.Content className="accordion-border">
                  <div className="fs-md mb-0 text-secondary">
                  Django is a vast collection of Python libraries that lets you resourcefully and rapidly develop top-class web applications and supports both backend as well as frontend development.
                    </div>
                </Accordion.Content>
              </Accordion.Panel>
              <Accordion.Panel>
                <Accordion.Title as="h3"  className="accordion-title"> Which big brands use Django?</Accordion.Title>
                <Accordion.Content className="accordion-border">
                  <div className="fs-md mb-0 text-secondary">
                  Several popular brands such as Instagram, National Geographic, Mozilla, Spotify, Pinterest, Disqus, Bitbucket, Eventbrite, Prezi, The Washington Post, The Guardian, The New York Post, and more have employed the Django framework for their development projects.
                    </div>
                </Accordion.Content>
              </Accordion.Panel>
              <Accordion.Panel>
                <Accordion.Title as="h3"  className="accordion-title">What are the benefits of choosing Django development?</Accordion.Title>
                <Accordion.Content className="accordion-border">
                  <div className="fs-md mb-0 text-secondary">
                  Django is a dynamic Python-based open-source web framework that enables you to create complex database-driven websites with amazing features such as MVC architecture, security, default admin panel, object-relational mapper, and more.
                    </div>
                </Accordion.Content>
              </Accordion.Panel>
              <Accordion.Panel>
                <Accordion.Title as="h3"  className="accordion-title">How much will it cost to develop a Django application?</Accordion.Title>
                <Accordion.Content className="accordion-border">
                  <div className="fs-md mb-0 text-secondary">
                  The cost of Django web development with Python will range from $5,000 to $50,000. Several other factors such as customization, the total time invested by the team, the complexity of the app, and others might change the above ballpark.
                  </div>
                </Accordion.Content>
              </Accordion.Panel>
            </Accordion>
        </>
        )
}

export default DjangoFAQ
